import { defineComponent as _defineComponent } from 'vue';
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BTab, BTabs } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { AUTO_EXTENSION, getUploadDatatypes } from "@/components/Upload/utils";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import CollectionCreatorFooterButtons from "./CollectionCreatorFooterButtons.vue";
import CollectionCreatorHelpHeader from "./CollectionCreatorHelpHeader.vue";
import CollectionCreatorNoItemsMessage from "./CollectionCreatorNoItemsMessage.vue";
import CollectionCreatorShowExtensions from "./CollectionCreatorShowExtensions.vue";
import CollectionCreatorSourceOptions from "./CollectionCreatorSourceOptions.vue";
import CollectionNameInput from "./CollectionNameInput.vue";
import DefaultBox from "@/components/Upload/DefaultBox.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreator',
    props: {
        oncancel: null,
        historyId: null,
        hideSourceItems: { type: Boolean },
        suggestedName: { default: "" },
        renderExtensionsToggle: { type: Boolean },
        extensions: { default: undefined },
        extensionsToggle: { type: Boolean, default: false },
        noItems: { type: Boolean },
        collectionType: { default: undefined },
        showUpload: { type: Boolean, default: true }
    },
    emits: ["remove-extensions-toggle", "clicked-create", "onUpdateHideSourceItems", "on-update-datatype-toggle", "add-uploaded-files"],
    setup(__props, { emit }) {
        const props = __props;
        const Tabs = {
            create: 0,
            upload: 1,
        };
        const currentTab = ref(Tabs.create);
        const collectionName = ref(props.suggestedName);
        const localHideSourceItems = ref(props.hideSourceItems);
        const listExtensions = ref([]);
        const extensionsSet = ref(false);
        const validInput = computed(() => {
            return collectionName.value.length > 0;
        });
        // If there are props.extensions, filter the list of extensions to only include those
        const validExtensions = computed(() => {
            return listExtensions.value.filter((ext) => props.extensions?.includes(ext.id));
        });
        // Upload properties
        const { config, isConfigLoaded } = useConfig();
        const { currentUser } = storeToRefs(useUserStore());
        const configOptions = computed(() => isConfigLoaded.value
            ? {
                chunkUploadSize: config.value.chunk_upload_size,
                fileSourcesConfigured: config.value.file_sources_configured,
                ftpUploadSite: config.value.ftp_upload_site,
                defaultDbKey: config.value.default_genome || "",
                defaultExtension: config.value.default_extension || "",
            }
            : {});
        const ftpUploadSite = computed(() => currentUser.value && "id" in currentUser.value ? configOptions.value.ftpUploadSite : null);
        const defaultExtension = computed(() => {
            if (!configOptions.value || !extensionsSet.value) {
                return "auto";
            }
            else if (!props.extensions?.length) {
                return configOptions.value.defaultExtension || "auto";
            }
            else {
                return props.extensions[0];
            }
        });
        const shortWhatIsBeingCreated = computed(() => {
            // plain language for what is being created
            if (props.collectionType === "list") {
                return "list";
            }
            else if (props.collectionType === "list:paired") {
                return "list of pairs";
            }
            else if (props.collectionType == "paired") {
                return "dataset pair";
            }
            else {
                return "collection";
            }
        });
        function addUploadedFiles(value) {
            // TODO: We really need to wait for each of these items to get `state = 'ok'`
            //       before we can add them to the collection.
            emit("add-uploaded-files", value);
        }
        function cancelCreate() {
            props.oncancel();
        }
        function removeExtensionsToggle() {
            emit("remove-extensions-toggle");
        }
        async function loadExtensions() {
            listExtensions.value = await getUploadDatatypes(false, AUTO_EXTENSION);
            extensionsSet.value = true;
        }
        loadExtensions();
        watch(() => localHideSourceItems.value, () => {
            emit("onUpdateHideSourceItems", localHideSourceItems.value);
        });
        return { __sfc: true, Tabs, props, emit, currentTab, collectionName, localHideSourceItems, listExtensions, extensionsSet, validInput, validExtensions, config, isConfigLoaded, currentUser, configOptions, ftpUploadSite, defaultExtension, shortWhatIsBeingCreated, addUploadedFiles, cancelCreate, removeExtensionsToggle, loadExtensions, faPlus, faUpload, FontAwesomeIcon, BTab, BTabs, localize, CollectionCreatorFooterButtons, CollectionCreatorHelpHeader, CollectionCreatorNoItemsMessage, CollectionCreatorShowExtensions, CollectionCreatorSourceOptions, CollectionNameInput, DefaultBox };
    }
});
